$(document).ready(async function () {
  await ResourceCoordinator.requestVendor('Beefup')

  $('.accordion-wrapper').beefup({
    trigger: ".accordion",
    content: ".accordion__content",
    openSpeed: 100,
    closeSpeed: 100
  });
})

class FaqTabs extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.initEventListeners()
  }

  initEventListeners() {
    this.querySelectorAll('.tab_link').forEach((tab) => {
      tab.addEventListener('click', this.handleTabClicked.bind(this))
    })
  }

  handleTabClicked(event) {
    const tabName = event.target.getAttribute('data-tab')
    const tabs = this.querySelectorAll('.tab_contents')
    const buttons = this.querySelectorAll('.tab_link')

    tabs.forEach((tab) => {
      const _tabName = tab.getAttribute('data-tab')
      if (_tabName === tabName) {
        tab.classList.add('block')
        tab.classList.remove('hidden')
      } else {
        tab.classList.remove('block')
        tab.classList.add('hidden')
      }
    })

    buttons.forEach((button) => {
      const _tabName = button.getAttribute('data-tab')
      if (_tabName === tabName) {
        button.classList.add('border-b-2')
      } else {
        button.classList.remove('border-b-2')
      }
    })
  }
}

customElements.define('faq-tabs', FaqTabs)